import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { NavLink, useParams } from 'react-router-dom'
import { ownFuelStationsMenu } from '../../utils/constants/navlinks-Menu'
import HeaderView from '../common/common-header/HeaderView'
import { OwnFuelStationsService } from '../../services/own-fuel-stations/ownFuelStations.service'
import useAccess from '../../utils/hooks/useAccess'
import { SpainFuelStationsService } from '../../services/spain-fuel-stations/spainFuelStations.service'
import './navLinkMenu.scss'

const OwnFuelStationNavLinkMenu = () => {
  const intl = useIntl()
  const { id } = useParams()

  const { canGet } = useAccess()
  const [fuelStation, setFuelStation] = useState()
  const [prices, setPrices] = useState(null)

  useEffect(() => {
    getOwnFuelStationData()
  }, [id])

  const getOwnFuelStationData = async () => {
    const resp = await OwnFuelStationsService.getById(id)
    if (resp) {
      setFuelStation(resp?.resp)
      const idMinetur = resp?.resp?.minetur?.id
      // esto se tiene q cambiar por ALVIC
      if (idMinetur) getPriceMineturByIdMinetur(resp?.resp?.minetur?.id)
    }
  }

  const getPriceMineturByIdMinetur = async (idMinetur) => {
    const resp = await SpainFuelStationsService.getPriceMinetur(idMinetur)
    if (resp) {
      setPrices([resp?.resp])
    }
  }

  return (
    <div className="header-menu">
      <HeaderView
        title={fuelStation?.centerName}
        pricesOwnStation={prices}
        showBackButton
      />
      <div className="navlink-menu">
        {ownFuelStationsMenu.map(
          (navLink, i) =>
            canGet(navLink.module, navLink.group) && (
              <NavLink
                key={i}
                to={navLink?.path(id)}
                className="navlink-item"
                activeclassname="active"
              >
                {intl.formatMessage({ id: navLink?.id })}
              </NavLink>
            ),
        )}
      </div>
    </div>
  )
}

export default OwnFuelStationNavLinkMenu
